<template>
  <a-config-provider :locale="locale" v-if="show">
    <div id="app">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { mapMutations } from 'vuex'
import { getDimensionList } from '@/api/request/park'
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN,
      show: true
    }
  },
  mounted() {
    // 获取维度数据
    this.getData()

    if (JSON.stringify(this.$store.state.userInfo) === '{}' || !this.$store.state.userInfo) {
      this.$store.dispatch('GetUserInfo')
    }
  },
  methods: {
    ...mapMutations(['setDimensionList']),
    async getData() {
      const typeMap = [
        'industryType', // 产业类型
        'parkType', // 园区类型
        'parkCarrier', // 园区载体
        'parkLabel', // 园区标签
        'feedBack' // 反馈类型
      ]

      let fns = typeMap.map((item) => {
        let params = {
          type: item
        }
        return getDimensionList(params)
      })
      this.show = false
      // getDimensionList
      try {
        let result = await Promise.all(fns)
        result = result.map((item) => item.data.data)
        this.setDimensionList(result)
        this.show = true
      } catch (error) {
        this.show = true
      }
    }
  }
}
</script>

<style lang="less">
@import './styles/default.less';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  color: @gray-color;
  // height: 100%;
  min-width: 1400px;
  background: @default-color;
}

body {
  height: 100%;
}
</style>
